import { format } from "date-fns";
import { formatPrice } from "../../../utils";

export default class BoletoApiEntity {
  CedenteContaNumero = null;
  CedenteContaNumeroDV = null;
  CedenteConvenioNumero = null;
  CedenteContaCodigoBanco = null;

  SacadoCPFCNPJ = null;
  SacadoEmail = null;
  SacadoEnderecoNumero = null;
  SacadoEnderecoBairro = null;
  SacadoEnderecoCEP = null;
  SacadoEnderecoCidade = null;
  SacadoEnderecoComplemento = null;
  SacadoEnderecoLogradouro = null;
  SacadoEnderecoPais = null;
  SacadoEnderecoUF = null;
  SacadoNome = null;
  SacadoTelefone = null;
  SacadoCelular = null;

  TituloCarteira = null;
  TituloDataEmissao = null;
  TituloDataVencimento = null;
  TituloMensagem01 = null;
  // TituloMensagem02 = null;
  // TituloMensagem03 = null;
  TituloNossoNumero = null;
  TituloNumeroDocumento = null;
  TituloValor = null;
  TituloLocalPagamento = null;
  TituloCodBaixaDevolucao = null;
  TituloPrazoBaixa = null;
  TituloVariacaoCarteira = null;
  TituloCodigoJuros = null;
  TituloValorJuros = null;
  TituloDataJuros = null;
  TituloCodigoMulta = null;
  TituloValorMultaTaxa = null;
  TituloDataMulta = null;
  TituloCodigoMulta = null;
  TituloValorMultaTaxa = null;
  TituloDataMulta = null;
  TituloCodDesconto = null;
  TituloValorDescontoTaxa = null;
  TituloDataDesconto = null;
  hibrido = null;

  constructor(boleto, nfSaida, nossoNumero) {
    const { conta, convenioSelecionado } = boleto;

    this.hibrido = convenioSelecionado.boletoHibrido;

    this.CedenteContaNumero = conta.conta;
    this.CedenteContaNumeroDV = conta.digitoConta;
    this.CedenteConvenioNumero = convenioSelecionado.numero;
    this.CedenteContaCodigoBanco = conta.banco.codigo;
    this.TituloCarteira = convenioSelecionado.carteira;
    this.SacadoCPFCNPJ = nfSaida.clienteCnpjCpf;
    this.SacadoEmail = nfSaida.clienteEmail;

    const endereco = nfSaida.nfSaidaEnderecoCliente;
    this.SacadoEnderecoNumero = endereco.numero;
    this.SacadoEnderecoBairro = endereco.bairro;
    this.SacadoEnderecoCEP = endereco.cep;
    this.SacadoEnderecoCidade = endereco.cidade;
    this.SacadoEnderecoComplemento = endereco.complemento;
    this.SacadoEnderecoLogradouro = endereco.logradouro;
    this.SacadoEnderecoPais = endereco.pais ?? "Brasil";
    this.SacadoEnderecoUF = endereco.estado;
    this.SacadoNome = nfSaida.clienteNome;
    this.SacadoTelefone = nfSaida.clienteTelefone;
    this.SacadoCelular = nfSaida.clienteCelular;

    const hoje = new Date();
    this.TituloDataEmissao = format(hoje, "dd/MM/yyyy");
    this.TituloDataVencimento = format(boleto.dataVencimento, "dd/MM/yyyy");
    this.TituloMensagem01 = convenioSelecionado.instrucoes;
    this.TituloNossoNumero = nossoNumero;
    this.TituloNumeroDocumento = boleto.tituloDocumento;
    this.TituloValor = formatPrice(boleto.valorTitulo, false);
    this.TituloLocalPagamento = "Pagável em qualquer banco até o vencimento.";
    this.TituloCodBaixaDevolucao = convenioSelecionado.codigoBaixaDevolucao;
    this.TituloPrazoBaixa = convenioSelecionado.prazoBaixa;

    if (conta.banco.codigo === "001") {
      this.TituloVariacaoCarteira = convenioSelecionado.variacaoCarteira;
    }
    if (conta.banco.codigo !== "341") {
      const diasCarencia = convenioSelecionado.carencia || 0;
      const dataCarencia = new Date(boleto.dataVencimento);
      dataCarencia.setDate(boleto.dataVencimento.getDate() + diasCarencia);
      const dataDesconto = new Date(boleto.dataVencimento);
      dataDesconto.setDate(boleto.dataVencimento.getDate() - diasCarencia);

      if (convenioSelecionado.taxaJuros && convenioSelecionado.taxaJuros > 0) {
        this.TituloCodigoJuros = 2;
        this.TituloValorJuros = formatPrice(
          convenioSelecionado.taxaJuros,
          false,
        );
        this.TituloDataJuros = format(dataCarencia, "dd/MM/yyyy");
      }

      if (
        convenioSelecionado.valorMulta &&
        convenioSelecionado.valorMulta > 0
      ) {
        this.TituloCodigoMulta = 1;
        this.TituloValorMultaTaxa = formatPrice(
          convenioSelecionado.valorMulta,
          false,
        );
        this.TituloDataMulta = format(dataCarencia, "dd/MM/yyyy");
      }

      if (convenioSelecionado.taxaMulta && convenioSelecionado.taxaMulta > 0) {
        this.TituloCodigoMulta = 2;
        this.TituloValorMultaTaxa = convenioSelecionado.taxaMulta
          .toString()
          .replace(".", ",");
        this.TituloDataMulta = format(dataCarencia, "dd/MM/yyyy");
      }

      if (
        convenioSelecionado.taxaDesconto &&
        convenioSelecionado.taxaDesconto > 0 &&
        convenioSelecionado.diaLimiteDesconto &&
        convenioSelecionado.diaLimiteDesconto >= 0
      ) {
        this.TituloCodDesconto = 2;
        this.TituloValorDescontoTaxa = convenioSelecionado.taxaDesconto
          .toString()
          .replace(".", ",");
        this.TituloDataDesconto = format(dataDesconto, "dd/MM/yyyy");
      }
    }
  }
}
